module.exports = __webpack_public_path__ + "static/media/DeleteTaskIcon.3516ad01.svg";